import * as React from "react"
import ReactDOM from "react-dom"
import { IntlProvider } from "react-intl"
import StoreFactory from "../redux/StoreFactory"
import storage from "redux-persist/lib/storage/session" // Session Storage
import reducers, { initialState } from "../redux/reducers/where2go"
import { IStoreConfig } from "../interfaces/storeFactory"
import Where2go from "../components/Where2go"

declare const mb:{where2go:{messages: Record<string, string>, locale: string}}

const renderApp = () => {
    const storeConfig = {
        reducers,
        initialState,
        persistConfig: {
            version: 0,
            key: "where2go",
            storage,
        }
    } as IStoreConfig

    ReactDOM.render(
        <StoreFactory config={storeConfig}>
            <IntlProvider messages={mb.where2go.messages} locale={mb.where2go.locale}>
                <Where2go />
            </IntlProvider>
        </StoreFactory>
        ,
        document.getElementById("wheretogo_map")
    )
}

renderApp()